const headers = {
  'x-api-key': process.env.API_KEY_SLACK,
}

export const state = () => ({
  sendMensageSlack: null,
})

export const getters = {}

export const mutations = {}

export const actions = {
  async sendMessageSlack({ commit }, message) {
    const url = 'https://578vlxlr78.execute-api.us-east-2.amazonaws.com/dev/v1'
    await this.$axios.$post(url, message, {
      headers,
    })
  },
}
